module.exports = __webpack_public_path__ + "static/media/alert_centre_filter_icon.8074f643.svg";